// import { Navigate, Outlet } from "react-router-dom";

// const RequireAuth = () => {
//   const token = localStorage.getItem("token");

//   if (!token) {
//     return <Navigate to="/signin" replace />;
//   }

//   return <Outlet />;
// };

// export default RequireAuth;


import { Navigate, Outlet, useLocation } from "react-router-dom";

const RequireAuth = () => {
    const token = localStorage.getItem("token");
    const location = useLocation();

    if (!token) {
        return (
            <Navigate
                to={`/signin?redirect=${encodeURIComponent(
                    location.pathname + location.search
                )}`}
                replace
            />
        );
    }

    return <Outlet />;
};

export default RequireAuth;